import React, { useState } from "react";

// React Google Recaptcha
import ReCAPTCHA from "react-google-recaptcha";

// Helpers
import { validateEmail } from "../helpers/validateEmail";

// API
import { sendContactUsMail } from "../api/contactUs"

const Contact = () => {
  const [fullNameInvalid, setFullNameInvalid] = useState(false);
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [emailInvalidMsg, setEmailInvalidMsg] = useState('');
  const [phoneInvalid, setPhoneInvalid] = useState(false);
  const [subjectInvalid, setSubjectInvalid] = useState(false);
  const [messageInvalid, setMessageInvalid] = useState(false);

  const [isCaptchaCorrect, setCaptchaCorrect] = useState(false);
  const [captchaError, setCaptchaError] = useState(false)

  const [form, setForm] = useState({
    full_name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    marketing: false,
  })

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setForm({
      ...form,
      [name]: value
    })
  }

  const onChangeCaptcha = (value) => {
    setCaptchaError(false)
    if (value) {
        setCaptchaCorrect(true);
    } else {
        setCaptchaCorrect(false);
    }
  };

  const handleValidationForm = async () => {
    let fullNameInvalid = false;
    let emailInvalid = false;
    let phoneNumberInvalid = false;
    let subjectInvalid = false;
    let messageInvalid = false;

    const {
      full_name,
      email,
      phone,
      subject,
      message,
    }  = form

    if (!full_name) {
      fullNameInvalid = true;
    }

    if (!email) {
      emailInvalid = true;
      setEmailInvalidMsg('Email is required')
    } else {
      if (validateEmail(email) !== true) {
        emailInvalid = true;
        setEmailInvalidMsg('Invalid email address')
      }
    }

    if (!phone) {
      phoneNumberInvalid = true;
    }

    if (!subject) {
      subjectInvalid = true;
    }

    if (!message) {
      messageInvalid = true;
    }

    if (!isCaptchaCorrect) {
      setCaptchaError(true)
    }

    setFullNameInvalid(fullNameInvalid)
    setEmailInvalid(emailInvalid)
    setPhoneInvalid(phoneNumberInvalid)
    setSubjectInvalid(subjectInvalid)
    setMessageInvalid(messageInvalid)

    if (
      fullNameInvalid !== true &&
      emailInvalid !== true &&
      phoneNumberInvalid !== true &&
      subjectInvalid !== true &&
      messageInvalid !== true
    ) {
      await submitForm()
    }
  }

  const submitForm = async () => {
    const payload = {
      full_name: form.full_name,
      email: form.email,
      phone: form.phone,
      subject: form.subject,
      message: form.message,
      marketing: form.marketing
    }
    await sendContactUsMail(payload)
  }

  return (
    <div className="main-container">
      <div className="max-w-main py-8 lg:py-16 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8">
        <div>
          <p className="text-xl lg:text-3xl font-bold mb-6 lg:mb-12 text-center md:text-left text-maplexxon-purple maplexxon-animation-end">
            Contact us
          </p>
          <p className="text-base lg:text-xl text-center md:text-left mb-8 maplexxon-animation-end">
            Have questions? We are here to help you.
          </p>
          <div>
            <p className="text-sm lg:text-base mb-2 font-bold uppercase maplexxon-animation-end">
              Our Store
            </p>
            <div className="text-xs lg:text-sm mb-4 maplexxon-animation-end">
              Duis a egestas tortor. Nam justo ipsum, euismod ut sodales viverra, fringilla posuere enim. Ut laoreet consectetur urna, ut convallis nulla blandit nec. Vestibulum tempus odio vel neque pulvinar, in scelerisque arcu egestas. Curabitur sem ipsum, iaculis in velit eu, venenatis egestas dui.
            </div>
          </div>
          <div>
            <p className="text-sm lg:text-base mb-2 font-bold uppercase maplexxon-animation-end">
              Operating Hours
            </p>
            <p className="text-xs lg:text-sm mb-4 maplexxon-animation-end">
              Monday to Friday 10:00 - 18:00
            </p>
          </div>
          <div>
            <p className="text-sm lg:text-base mb-2 font-bold uppercase maplexxon-animation-end">
              Contact Us
            </p>
            <p className="text-xs lg:text-sm mb-2 space-x-2 maplexxon-animation-end">
              <span>+62 812 3456 7890</span>
              <button>
                <svg class="h-3 w-3 sm:h-4 sm:w-4 fill-black" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 0C6.2678 0 0 6.2678 0 14C0 16.646 0.735 19.124 2.0132 21.2352L0.7644 25.48C0.692698 25.7237 0.687981 25.9822 0.750742 26.2284C0.813504 26.4746 0.941427 26.6993 1.12106 26.8789C1.3007 27.0586 1.52541 27.1865 1.77158 27.2493C2.01775 27.312 2.27628 27.3073 2.52 27.2356L6.7648 25.9868C8.94695 27.3071 11.4495 28.0035 14 28C21.7322 28 28 21.7322 28 14C28 6.2678 21.7322 0 14 0ZM10.8332 17.1682C13.6654 19.999 16.3688 20.3728 17.3236 20.4078C18.7754 20.461 20.1894 19.3522 20.7396 18.0656C20.8091 17.9055 20.8343 17.7298 20.8126 17.5567C20.7909 17.3835 20.7232 17.2194 20.6164 17.0814C19.8492 16.1014 18.8118 15.3972 17.7982 14.6972C17.5866 14.5509 17.3265 14.4922 17.0725 14.5334C16.8186 14.5747 16.5905 14.7126 16.436 14.9184L15.596 16.1994C15.5518 16.2683 15.483 16.3176 15.4036 16.3374C15.3243 16.3572 15.2403 16.3459 15.169 16.3058C14.5992 15.9796 13.769 15.4252 13.1726 14.8288C12.5762 14.2324 12.0554 13.44 11.7628 12.9066C11.7265 12.8388 11.716 12.7602 11.7333 12.6853C11.7505 12.6104 11.7943 12.5443 11.8566 12.4992L13.1502 11.5388C13.3348 11.3783 13.4539 11.1555 13.4849 10.9128C13.5159 10.6701 13.4566 10.4246 13.3182 10.2228C12.691 9.3044 11.9602 8.1368 10.9004 7.3626C10.7636 7.26349 10.6034 7.20168 10.4355 7.18327C10.2676 7.16486 10.0978 7.19048 9.9428 7.2576C8.6548 7.8092 7.5404 9.2232 7.5936 10.6778C7.6286 11.6326 8.0024 14.336 10.8332 17.1682Z"></path>
                </svg>
              </button>
            </p>
            <p className="text-xs lg:text-sm mb-2 space-x-2 maplexxon-animation-end">
              <span>+6221 2345 6789</span>
              <button disabled>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 sm:h-4 sm:w-4 fill-black" x="0" y="0" viewBox="0 0 512 512"><g><path d="M496.995 482h-16V227.006a14.999 14.999 0 0 0-10.257-14.23l-169.739-56.58v-51.187c0-6.253-3.878-11.85-9.733-14.045L51.272.966c-9.796-3.673-20.267 3.58-20.267 14.045v466.99h-16c-8.284 0-15 6.716-15 15s6.716 15 15 15h481.99c8.284 0 15-6.716 15-15s-6.716-15.001-15-15.001zm-345.993 0h-29.999v-59.999h29.999V482zm59.999 0h-29.999v-59.999h29.999V482zM271 167.007V482h-29.999v-74.998c0-8.284-6.716-15-15-15H106.003c-8.284 0-15 6.716-15 15V482H61.004V36.655L271 115.403v51.604zM390.997 482h-29.999v-59.999h29.999V482zm59.999 0h-29.999v-74.998c0-8.284-6.716-15-15-15h-59.999c-8.284 0-15 6.716-15 15V482h-29.999V187.818l149.997 49.999V482z" fill="#000000"></path><path d="M136.003 332.003h-29.999c-8.284 0-15 6.716-15 15s6.715 15 15 15h29.999c8.284 0 15-6.716 15-15s-6.716-15-15-15zM226.001 332.003h-29.999c-8.284 0-15 6.716-15 15s6.715 15 15 15h29.999c8.284 0 15-6.716 15-15s-6.716-15-15-15zM136.003 272.005h-29.999c-8.284 0-15 6.716-15 15s6.715 15 15 15h29.999c8.284 0 15-6.716 15-15s-6.716-15-15-15zM226.001 272.005h-29.999c-8.284 0-15 6.716-15 15s6.715 15 15 15h29.999c8.284 0 15-6.716 15-15s-6.716-15-15-15zM405.997 332.003h-59.999c-8.284 0-15 6.716-15 15s6.715 15 15 15h59.999c8.284 0 15-6.716 15-15s-6.716-15-15-15zM405.997 272.005h-59.999c-8.284 0-15 6.716-15 15s6.715 15 15 15h59.999c8.284 0 15-6.716 15-15s-6.716-15-15-15zM136.003 212.006h-29.999c-8.284 0-15 6.716-15 15 0 8.284 6.715 15 15 15h29.999c8.284 0 15-6.716 15-15-.001-8.284-6.716-15-15-15zM226.001 212.006h-29.999c-8.284 0-15 6.716-15 15 0 8.284 6.715 15 15 15h29.999c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zM136.003 152.007h-29.999c-8.284 0-15 6.716-15 15 0 8.284 6.715 15 15 15h29.999c8.284 0 15-6.716 15-15-.001-8.284-6.716-15-15-15zM226.001 152.007h-29.999c-8.284 0-15 6.716-15 15 0 8.284 6.715 15 15 15h29.999c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15z" fill="#000000"></path></g></svg>
              </button>
            </p>
            <p className="text-xs lg:text-sm mb-2 space-x-2 maplexxon-animation-end">
              sales@moonlightstore.com
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label for="full_name" class="text-xs font-bold uppercase">Full name</label>
            <input id="full_name" name="full_name" class="text-left px-3 py-2 rounded-md border border-maplexxon-grey-2 text-xs text-maplexxon-blue-green" placeholder="Enter your full name" autocomplete="off" value={form.full_name} onChange={handleChange}></input>
            {
              fullNameInvalid && (
                <p className='text-xs text-red-500'>Full name is required</p>
              )
            }
          </div>
          <div className="flex flex-col gap-2">
            <label for="email_address" class="text-xs font-bold uppercase">Email Address</label>
            <input id="email" name="email" class="text-left px-3 py-2 rounded-md border border-maplexxon-grey-2 text-xs text-maplexxon-blue-green" placeholder="Enter your email address" autocomplete="off" value={form.email} onChange={handleChange}></input>
            {
              emailInvalid && (
                <p className='text-xs text-red-500'>{emailInvalidMsg}</p>
              )
            }
          </div>
          <div className="flex flex-col gap-2">
            <label for="phone_number" class="text-xs font-bold uppercase">Phone Number</label>
            <input id="phone" name="phone" type="number" class="text-left px-3 py-2 rounded-md border border-maplexxon-grey-2 text-xs text-maplexxon-blue-green" placeholder="Enter your phone number" autocomplete="off" value={form.phone} onChange={handleChange}></input>
            {
              phoneInvalid && (
                <p className='text-xs text-red-500'>Phone number is required</p>
              )
            }
          </div>
          <div className="flex flex-col gap-2">
            <label for="subject" class="text-xs font-bold uppercase">Subject</label>
            <input id="subject" name="subject" class="text-left px-3 py-2 rounded-md border border-maplexxon-grey-2 text-xs text-maplexxon-blue-green" placeholder="Enter your subject" autocomplete="off" value={form.subject} onChange={handleChange}></input>
            {
              subjectInvalid && (
                <p className='text-xs text-red-500'>Subject is required</p>
              )
            }
          </div>
          <div className="flex flex-col gap-2">
            <label for="your_message" class="text-xs font-bold uppercase">Your Message</label>
            <textarea id="message" name="message" class="text-left px-3 py-2 rounded-md border border-maplexxon-grey-2 text-xs text-maplexxon-blue-green" placeholder="Enter your message here" rows="8" autocomplete="off" value={form.message} onChange={handleChange}></textarea>
            {
              messageInvalid && (
                <p className='text-xs text-red-500'>Message is required</p>
              )
            }
          </div>
          <div className={`w-min ${captchaError ? "border border-red-500" : ""}`}>
            <ReCAPTCHA
              sitekey="6Le7pvUaAAAAAAiPYg6vfzaD7kFju2jFBEYuvvaK"
              onChange={onChangeCaptcha}
            />
          </div>
          {captchaError && (
            <p className='text-xs text-red-500'>
                Please check the captcha box before you proceed
            </p>
          )}
          <div className='space-y-4'>
            <p className='text-xs lg:text-sm'>By registering, you confirm that you agree to the processing of your personal data by Moonlight as described in the <a className="underline" href='/privacypolicy' target='_blank' rel='noreferrer'>Privacy Policy</a></p>
            <div className='flex items-start gap-2'>
                <input
                    type='checkbox'
                    id="marketing"
                    name="marketing"
                    value={form.marketing}
                    onChange={handleChange}
                />
                <label htmlFor="marketing" className='text-xs lg:text-sm'>
                    Yes, I would like to receive marketing communications about the Moonlight. I can unsubscribe at any time.
                </label>
            </div>
          </div>
          <button 
            // disabled={!form.full_name || !form.email || !form.phone || !form.subject || !form.message}
            class="flex-1 text-sm lg:text-base bg-maplexxon-blue text-white px-6 py-2 rounded-md disabled:bg-slate-300"
            onClick={handleValidationForm}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  )
}

export default Contact;